import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import useEditCourse from "./useEditCourse";
import {useParams} from "react-router-dom";
import GeneralEditCourseForm from "../utils/GeneralEditCourseForm";
import useLoadCourse from "../utils/useLoadCourse";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import LastUpdateInfo from "../../../../commons/utils/lastUpdate/LastUpdateInfo";
import {useIntl} from "react-intl";

const EditCourseSection = () => {

    // The selected course id from the list (provided as parameter)
    const {key} = useParams()

    const {course, loading} = useLoadCourse(key)

    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the edit course functionality
    const {save, saveInProgress, cancel} = useEditCourse()

    // Reference, which holds will hold the course data according to the current form data
    const editedCourseRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({id: 'app.courses.edit.appbar.header', defaultMessage: 'Edit Course'}),
            description: <LastUpdateInfo metadata={course?.metadata}/>,
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({id: 'app.courses.edit.appbar.actions.save', defaultMessage: 'Save'})}
                    onClick={() => save(editedCourseRef.current)} icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({id: 'app.courses.edit.appbar.actions.cancel', defaultMessage: 'Cancel'})}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, course, saveInProgress])

    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.courses.edit.loading', defaultMessage: 'Loading Course...'})}/>
    }

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.courses.edit.save.loading', defaultMessage: 'Saving Course...'})}/>
    }

    return (
        <GeneralEditCourseForm selectedCourse={course}
                               editedCourseRef={editedCourseRef}
                               setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default EditCourseSection